import React from 'react';
import { Box } from '@mui/system';
import { CustomIcon } from 'components/CustomIcon';
import { useIsMobileDevice } from 'utils';
import * as Styled from '../SearchAutocompleteResults.styles';
import {
  SearchAutocompleteResultsProps,
  AutocompleteItemType,
} from '../SearchAutocompleteResults.types';
import { RowItem } from './RowItem';

export const SearchHistory: React.FC<
  Partial<SearchAutocompleteResultsProps>
> = ({
  searchHistory,
  onItemClick,
  onItemHover,
  query,
  shouldShowDividers,
  shouldShowArrows,
  shouldShowClearItemButton,
  maxHistoryItemsCount,
  maxMobileHistoryItemsCount,
  invertQueryHighlighting,
  onClearItem,
  selectedItemId,
}) => {
  const handleItemClick = (item: string) => {
    onItemClick?.(item, AutocompleteItemType.HISTORY);
  };

  const isMobileDevice = useIsMobileDevice();
  const splittedSearchHistory = React.useMemo(
    () =>
      searchHistory?.slice(
        0,
        isMobileDevice ? maxMobileHistoryItemsCount : maxHistoryItemsCount,
      ),
    [
      searchHistory,
      isMobileDevice,
      maxHistoryItemsCount,
      maxMobileHistoryItemsCount,
    ],
  );

  const iconJSX = <CustomIcon name="clock" dense />;

  return (
    <Box display="flex" flexDirection="column">
      <Box display="flex" flexDirection="column">
        {splittedSearchHistory?.map((history, index) => {
          const isSelected = history.id === selectedItemId;
          return (
            <React.Fragment key={history.value + index}>
              {shouldShowDividers && <Styled.RowDivider />}
              <RowItem
                index={index}
                type={AutocompleteItemType.HISTORY}
                key={history.id}
                item={history}
                query={query}
                onClick={handleItemClick}
                onItemHover={onItemHover}
                shoudShowImage={false}
                customIcon={iconJSX}
                shouldShowDividers={shouldShowDividers}
                shouldShowIcon
                shouldShowArrows={shouldShowArrows}
                shouldShowClearButton={shouldShowClearItemButton}
                invertQueryHighlighting={invertQueryHighlighting}
                onClear={onClearItem}
                isSelected={isSelected}
              />
            </React.Fragment>
          );
        })}
      </Box>
    </Box>
  );
};
